<template>
    <div class="ak-overlay">
        <div class="ak-modal">
            <div class="ak-modal-head">
                <div class="ak-modal-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.78 7.78 5.5 5.5 0 0 1 7.78-7.78zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
                    </svg>
                </div>
                <div>
                    <h2>{{ reveal.title }}</h2>
                    <p>{{ reveal.name }}</p>
                </div>
            </div>

            <div class="ak-modal-body">
                <div class="ak-warn">
                    This is the only time the {{ reveal.signing_secret ? 'key and signing secret are' : 'key is' }} shown.
                    It is stored hashed and cannot be recovered. Copy it now and share it over a secure channel.
                </div>

                <div class="rv-block">
                    <span class="ak-label">Base URL</span>
                    <div class="rv-box">
                        <code>{{ baseUrl }}</code>
                        <button type="button" class="ak-btn ghost rv-copy" @click="copy('url', baseUrl)">
                            {{ copied === 'url' ? 'Copied' : 'Copy' }}
                        </button>
                    </div>
                    <p class="ak-hint">
                        Send requests to this URL, for example <code>https://api.bidsnap.in/api/v1/tenders</code>.
                        Put the API key in the <code>X-API-Key</code> header.
                    </p>
                </div>

                <div class="rv-block">
                    <span class="ak-label">API key</span>
                    <div class="rv-box">
                        <code>{{ reveal.api_key }}</code>
                        <button type="button" class="ak-btn ghost rv-copy" @click="copy('key', reveal.api_key)">
                            {{ copied === 'key' ? 'Copied' : 'Copy' }}
                        </button>
                    </div>
                </div>

                <div v-if="reveal.signing_secret" class="rv-block">
                    <span class="ak-label">Signing secret</span>
                    <div class="rv-box">
                        <code>{{ reveal.signing_secret }}</code>
                        <button type="button" class="ak-btn ghost rv-copy" @click="copy('secret', reveal.signing_secret)">
                            {{ copied === 'secret' ? 'Copied' : 'Copy' }}
                        </button>
                    </div>
                    <p class="ak-hint">Used to sign requests for this key (signed mode).</p>
                </div>

                <label class="ak-check rv-confirm">
                    <input type="checkbox" v-model="saved">
                    I have saved {{ reveal.signing_secret ? 'both values' : 'this key' }} somewhere safe
                </label>

                <div class="ak-actions">
                    <button type="button" class="ak-btn primary" :disabled="!saved" @click="$emit('close')">Done</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { copyText } from './apiKeysCommon';

export default {
    name: 'ApiKeyReveal',
    props: {
        reveal: { type: Object, required: true },
    },
    emits: ['close'],
    data() {
        return { saved: false, copied: '' };
    },
    computed: {
        // The panel talks to the same backend host the public API is served from,
        // so VUE_APP_API_URL (localhost in dev, https://api.bidsnap.in in prod) + /api/v1.
        baseUrl() {
            return `${String(this.$API_URL || '').replace(/\/+$/, '')}/api/v1`;
        },
    },
    methods: {
        async copy(which, text) {
            const ok = await copyText(text);
            if (ok) {
                this.copied = which;
                setTimeout(() => { if (this.copied === which) this.copied = ''; }, 2000);
            }
        },
    },
};
</script>

<style scoped>
.rv-block { display: flex; flex-direction: column; gap: 0.4rem; }
.rv-box {
    display: flex; align-items: center; gap: 0.6rem; background: #0f172a; border-radius: 12px; padding: 0.7rem 0.8rem;
}
.rv-box code {
    flex: 1; min-width: 0; color: #34f0c0; font-size: 0.82rem; word-break: break-all; font-family: ui-monospace, Menlo, Consolas, monospace;
}
.rv-copy { flex: none; padding: 0.4rem 0.8rem; font-size: 0.78rem; }
.rv-confirm { margin-top: 0.25rem; }
</style>
